import React from "react"
import P24RestaurantChequeTransactions from "./P24RestaurantChequeTransactions";

/**
 * Komponent reprezentujący transakcje P24 dla konkretnej restauracji
 */
class RestaurantP24Transactions extends React.Component {

    componentDidMount() {
       
    }

    render() {
        return (
            <div>
                <h3>Transakcje P24 wybranej restauracji</h3>

                <P24RestaurantChequeTransactions restaurantId={this.props.match.params.id}/>

                <br /><br /><br />

            </div>
        )
    }
}

export default RestaurantP24Transactions;